import createReducer from 'state/reducerHelper';
import {
  dataSourceFailure,
  isLoadingDataState,
  apiServiceErrorReducer,
} from 'state/utils';
import { combineReducers } from 'redux';
import * as types from './types';

const ekgRecordingReducer = createReducer({})({
  [`${types.GET_EKG_RECORDING}_REJECTED`]: dataSourceFailure,
  [`${types.GET_EKG_RECORDING}_PENDING`]: isLoadingDataState,
  [`${types.GET_EKG_RECORDING}_FULFILLED`]: (state, action) => action.payload,
});

const postQTRequestReducer = createReducer({})({
  [`${types.POST_QT_REQUEST}_PENDING`]: isLoadingDataState,
  [`${types.POST_QT_REQUEST}_REJECTED`]: apiServiceErrorReducer,
  [`${types.POST_QT_REQUEST}_FULFILLED`]: (state, action) => action.payload,
});

const ekgQTReducer = createReducer({ status: null })({
  [`${types.POST_QT_REQUEST}_FULFILLED`]: (state, action) => action.payload,
  [`${types.GET_EKG_QT}_REJECTED`]: apiServiceErrorReducer,
  [`${types.GET_EKG_QT}_PENDING`]: isLoadingDataState,
  [`${types.GET_EKG_QT}_FULFILLED`]: (state, action) => action.payload,
});

const postQTValuesReducer = createReducer({})({
  [`${types.POST_QT_VALUES}_PENDING`]: isLoadingDataState,
  [`${types.POST_QT_VALUES}_REJECTED`]: apiServiceErrorReducer,
  [`${types.POST_QT_VALUES}_FULFILLED`]: (state, action) => action.payload,
});

export const EKG_RECORDING_REDUCERS = {
  EKG_RECORDING: 'recording',
  EKG_QT: 'qtAnalysis',
  POST_QT_REQUEST: 'qtRequest',
  POST_QT_VALUES: 'qtValues',
};

export default combineReducers({
  [EKG_RECORDING_REDUCERS.EKG_RECORDING]: ekgRecordingReducer,
  [EKG_RECORDING_REDUCERS.EKG_QT]: ekgQTReducer,
  [EKG_RECORDING_REDUCERS.POST_QT_REQUEST]: postQTRequestReducer,
  [EKG_RECORDING_REDUCERS.POST_QT_VALUES]: postQTValuesReducer,
});



// WEBPACK FOOTER //
// ./src/state/reducers/ekgRecordings/ekgRecordingReducers.js